import * as React from "react";

const Logo = () => {
    return (
        <img src="/images/logo.svg" alt="logo" />
        )
};
export default Logo;
